import { User } from '../../types';

export const userSelector = (state: any) => state.user.user as User;
